import { axios } from '@/utils/request'
import dictCode from '../constants/dict-code';
const codes = Object.values(dictCode).join(',');

export function getDictList (parameter = {}) {
  return axios({
    url: `/dict/findDictItemByCode/${codes}/anon`,
    method: 'post',
    data: parameter
  })
}
export function getDictList2 (parameter = {}) {
  return axios({
    url: `/dict/findDictItemByCode/${parameter.code}/anon`,
    method: 'post',
    data: parameter
  })
}
